import React from 'react'

import {Swiper, SwiperSlide} from 'swiper/react'
import {mireaSlider} from '../../../../routes/mireaSlider'

import styles from './styles.module.scss'
// import {Autoplay} from 'swiper'
import parse from "html-react-parser";

const MireaSlider = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <p className={styles.title}>Преимущества программы</p>
        <div className={styles.list}>
          <div className={styles.item}>
            <p className={styles.number}>17</p>
            <p className={styles.text_lg}>
              стажеров прошли программу <br/>Mabstudy с 2019 г.
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>11</p>
            <p className={styles.text_lg}>
              выпускников программы <br/>строят карьеру в Generium
            </p>
          </div>
          <div className={styles.item}>
            <p className={styles.number}>5+</p>
            <p className={styles.text_lg}>
              человек на место в конкурсе <br/>на программу
            </p>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>Почему Generium?</p>
        </div>
        <div className="slider871C6A">
          <div className={styles.slider}>
            <Swiper
              pagination={true}
              spaceBetween={16}
              slidesPerView={3}
              initialSlide={0}
              loop={true}
              speed={5000}
              // autoplay={{
              //   delay: 3000
              // }}
              // modules={[Autoplay]}
              breakpoints={{
                1440: {
                  slidesPerView: 3
                },
                1365: {
                  slidesPerView: 3
                },
                1025: {
                  slidesPerView: 2.3,
                  spaceBetween: 24
                },
                769: {
                  slidesPerView: 2.5,
                  spaceBetween: 16
                },
                686: {
                  slidesPerView: 3,
                  spaceBetween: 16
                },
                480: {
                  slidesPerView: 2,
                  spaceBetween: 16
                },
                380: {
                  slidesPerView: 1.5,
                  spaceBetween: 16
                },
                320: {
                  slidesPerView: 1.3,
                  spaceBetween: 16
                }
              }}
            >
              {mireaSlider !== undefined ?
                mireaSlider.map((item, index) => (
                  <>
                    <SwiperSlide key={item.id}>
                      <div className={styles.slider_item}>
                        <p className={styles.slider_item_p1}>{item.title}</p>
                        <img src={item.img} alt='icons' draggable='false'/>
                        <p className={styles.slider_item_p2}>{parse(item.text)}</p>
                      </div>
                    </SwiperSlide></>
                )) : ""}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MireaSlider
